export default __webpack_public_path__ + "static/media/brilliant_diamond_chunk.d600da7c.png";